import React from "react";
import { Link } from "react-router-dom";
import { EditorialPage } from "../components/editorial";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

// Real 404 page. Replaces the old catch-all that rendered the HOMEPAGE for any
// unknown URL, which made every typo'd or dead link a soft 404 (HTTP 200 +
// homepage canonical) — a crawl-budget and index-quality problem. The route
// renders via the `*` path in App.tsx; scripts/prerender.mjs writes it to
// dist/404.html, which Vercel serves with a genuine 404 status once no
// filesystem match or rewrite claims the path. SSR-safe: no effects, no data.
const NotFoundPage: React.FC = () => (
  <EditorialPage>
    <Navbar />
    <section className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center px-6 text-center">
      <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-teal">
        404
      </p>
      <h1 className="mt-3 text-4xl font-extrabold text-ink sm:text-5xl">
        This page isn&rsquo;t looping
      </h1>
      <p className="mt-4 text-lg text-body">
        The link may be old, or the page has moved. Everything that matters is
        one tap away.
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
        <Link
          to="/"
          className="rounded-full bg-salmon px-6 py-3 font-bold text-on-salmon"
        >
          Back home
        </Link>
        <Link to="/news" className="font-semibold text-teal underline">
          Read the guides
        </Link>
        <Link to="/communities" className="font-semibold text-teal underline">
          See communities
        </Link>
      </div>
    </section>
    <Footer />
  </EditorialPage>
);

export default NotFoundPage;
